// extracted by mini-css-extract-plugin
module.exports = {"message":"ScenariosError_message__XwuMp","text":"ScenariosError_text__mZGbT"};